<template>
    <v-list-item three-line>
        <v-list-item-content>
            <v-list-item-title v-text="title" class="mb-3 text-wrap" />
            <v-list-item-subtitle v-text="description" />
            <v-list-item-subtitle class="font-weight-bold" v-text="`${points} ${$t('Points')}`" />
        </v-list-item-content>

        <v-list-item-action tile class="mt-1">
            <v-btn icon @click="onIconClick">
                <v-icon color="primary">fas fa-angle-right</v-icon>
            </v-btn>
        </v-list-item-action>
    </v-list-item>
</template>

<script>
import moment from 'moment';

export default {
    props: {
        cardData: {
            type: Object,
        },
        clickHandler: {
            type: Function,
        },
    },
    computed: {
        title() {
            const participants = [...this.cardData.participants];
            const participant = this.cardData.isQrScanType ? participants.pop() : participants.shift();
            let title = participant.name;
            if (participants.length > 0) {
                title += ` & ${participants.length} ${this.$t('further')}`;
            }
            return title;
        },
        description() {
            return `${this.cardData.activityTitle}, ${moment(this.cardData.date.date).format('DD.MM.YY')}`;
        },
        points() {
            return this.cardData.points;
        },
    },
    methods: {
        onIconClick() {
            if (this.clickHandler) {
                this.clickHandler(this.cardData);
            }
        },
    },
};
</script>
